// Badge tier + category metadata
export const BADGE_TIERS = [
  { key: "Bronze", color: "#cd7f32", glow: "rgba(205,127,50,0.55)", chip: "bg-[#2a1d10] text-[#e0a86b] border-[#5e3e1f]" },
  { key: "Silver", color: "#c8d4e3", glow: "rgba(200,212,227,0.5)", chip: "bg-[#1a2030] text-[#e0e8f0] border-[#3a4258]" },
  { key: "Gold", color: "#f3c552", glow: "rgba(243,197,82,0.6)", chip: "bg-[#2a1f08] text-[#ffd870] border-[#7a5a1c]" },
  { key: "Platinum", color: "#79e6ff", glow: "rgba(121,230,255,0.55)", chip: "bg-[#0a2533] text-[#9ef0ff] border-[#1d5870]" },
  { key: "Diamond", color: "#d978ff", glow: "rgba(217,120,255,0.6)", chip: "bg-[#2a0e3a] text-[#ecb0ff] border-[#6b2a8c]" },
];

export const BADGE_CATEGORIES = [
  "Combat",
  "Industry",
  "Politics",
  "Social",
  "Exploration",
  "Wealth",
  "Special",
];

export function tierMeta(key) {
  return BADGE_TIERS.find(t => t.key === key) || BADGE_TIERS[0];
}
